export const formatGs = (n) => {
  const v = Math.round(Number(n) || 0);
  return "Gs. " + v.toLocaleString("es-PY");
};

export const LOCATION_NAMES = {
  sabornauta: "Sabornauta",
  compunauta: "Compunauta",
};

export const ROLE_LABELS = {
  "super-admin": "Super Admin",
  administrador: "Administrador",
  supervisor: "Supervisor",
  cajero: "Cajero",
};

export const formatDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("es-PY", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};
